import { render, staticRenderFns } from "./BaseBusiness.vue?vue&type=template&id=47a830b2&"
import script from "./BaseBusiness.vue?vue&type=script&lang=js&"
export * from "./BaseBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports